'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var BodyModel = require('src/common/page-model')

var ClientApiKeysList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      this.region = options.region

      var self = this
      //
      self.mailreports = App.globalChannel.request('mailreports:entities', {
        query: {
          client: options.client.get('_id')
        }
      })

      var bodyModel = new BodyModel({
        title: 'Reporting',
        buttons: [
          { label: 'add report', primary: true, slug: 'mailreport', action: 'client-mailreports:add', roles: ['super', 'admin'] }
        ]
      })

      self.layout = self.getLayoutView(bodyModel)

    //  self.layout.on('childview:client-users:edit', _.bind(self.onEdit, self))
      self.listenTo(self.layout, 'client-mailreports:add', self.onAdd, self)

      self.listenTo(self.layout, 'render', function () {
        self.listRegion(self.mailreports)
      })

      // view events
      self.region.show(self.layout)
    },
    /* Event methods --------------------------------------------------------- */
    onBulk: function (args) {
      switch (args.bulk_action) {
        case 'delete':
          App.dialog.confirm({
            message: 'Are you sure you want to peform a bulk delete?',
            callback: function (confirmed) {
              if (confirmed) {
                args.collection.bulkDelete({})
              }
            }
          })
          break
        default:
          console.warn('Bulk action not catched by switch, "' + args.bulk_action + '"')
          break
      }
    },
    onAdd: function (args) {
      console.log('aa')
      var self = this
      App.globalChannel.trigger('client-mailreports:new', {region: App.rootLayout.getRegion('dialogRegion'), client: self.options.client, collection: self.mailreports})
    },
    onRender: function (args) {
      // App.globalChannel.trigger('client:show', {model: args.model})
    },
    onSend: function (args) {
      let model = args.model

      App.dialog.prompt({
        message: 'Please enter a email address to test the mailing',
        callback: function (email) {
          model.test({recipients:email}, (err, response) => {
            console.log(err)
            console.log(response)
          })
          console.log(email)
          // if (confirmed) {
          //   args.collection.bulkDelete({})
          // }
        }
      })
    },
    onEdit: function (args) {
      App.globalChannel.trigger('client-mailreports:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    },
    /* Regions --------------------------------------------------------------- */
    listRegion: function (nodes, columns) {
      var self = this
      //
      var columns = {
        'enabled': {'label': '', 'sortable': false, 'roles': [] },
        'type': {'label': 'type', 'sortable': true, 'roles': [], 'hideSizes':['mobile']},
        'recipients': {'label': 'recipients', 'sortable': true, 'roles': [], 'hideSizes':['mobile','tablet'] },
        'interval': {'label': 'interval', 'sortable': true, 'roles': []},
        'createdAt': {'label': 'created at', 'sortable': true, 'roles': [], 'hideSizes':['mobile','tablet']},
        '_actions': {
          'options': {
            'mail-send': { 'action': 'send', 'roles': [] },
            'edit': { 'action': 'edit', 'roles': [] }            
          }
        }
      }

      //
      var emptyViewModel = new Backbone.Model({
        title: 'No subscriptions set yet.',
        subTitle: 'create some subscriptions to get started'
      })

      //
      var layout = this.getListView(nodes, columns, emptyViewModel)
      self.listenTo(layout, 'listview:childview:item:edit', self.onEdit)
      self.listenTo(layout, 'listview:childview:item:send', self.onSend)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      self.layout.getRegion('listRegion').show(layout)
    },
    /* Views ----------------------------------------------------------------- */
    getListView: function (collection, columns, emptyViewModel) {
      // create the listview based on the list component
      return new View.ListView({
        collection: collection,
        columns: columns,
        emptyViewModel: emptyViewModel,
        childView: View.ListItem // use a custom childview
      })
    },
    getLayoutView: function (model) {
      return new View.Layout({model: model})
    }
  })

  return new Controller(options)
}

module.exports = ClientApiKeysList



// WEBPACK FOOTER //
// ./js/modules/client-mailreports/list/index.js